import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles/index.css';
import tokens from './brand-tokens.json';

// The per-school accent's default is the brand accent token. Set here (not in
// the CSS) so brand-tokens.json stays the only hex-bearing file; SchoolPortal
// overrides it per school after the by-slug fetch.
document.documentElement.style.setProperty('--school-accent', tokens.colors.accent);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
